import { Trans } from "@lingui/react/macro";
import { useState } from "react";

import { useCurrentUser } from "@/features/auth";

import { CheckoutDialog } from "../CheckoutDialog";
import { ProStatusCard } from "../ProStatusCard";
import { PaymentMethods } from "./PaymentMethods";
import { PlanComparison } from "./PlanComparison";
import { PricingFaq } from "./PricingFaq";
import { SupportNote } from "./SupportNote";

type PricingPageProps = {
  // Платёж, с которого игрок вернулся со страницы оплаты (`/pricing?payment=…`).
  returnedPaymentId: string | null;
  // Окно оплаты закрыто — маршрут убирает `payment` из адреса.
  onCheckoutClosed: () => void;
};

// Страница «Тарифы» (`/pricing`) по макету design/prototype/ProGuest.dc.html. Открывается без
// входа: её смотрит модерация платёжного сервиса. Вошедшему — «Твой Pro» сверху и окно оплаты
// (design/prototype/ProCheckout.dc.html) по «Оформить». `GET /api/me` у гостя — 401, на
// странице без входа это не уводит на вход.
export const PricingPage = ({ returnedPaymentId, onCheckoutClosed }: PricingPageProps) => {
  const { data: user } = useCurrentUser();
  const signedIn = user !== undefined;
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const open = signedIn && (checkoutOpen || returnedPaymentId !== null);

  const openCheckout = () => {
    setCheckoutOpen(true);
  };

  return (
    <main
      data-page="pricing"
      className="mx-auto flex w-full max-w-[880px] flex-col gap-6 px-6 pt-8 pb-14"
    >
      <div className="flex flex-col gap-2">
        <h1 className="font-display text-[40px] leading-[1.1]">
          <Trans>Plans</Trans>
        </h1>
        <p className="max-w-[62ch] text-base text-foreground-soft">
          <Trans>
            Relock is a personal Deadlock coach: it analyzes your matches and compares you with
            strong players on the same hero.
          </Trans>
        </p>
      </div>
      <ProStatusCard signedIn={signedIn} onExtend={openCheckout} />
      <PlanComparison signedIn={signedIn} onGetPro={openCheckout} />
      <SupportNote />
      <PaymentMethods />
      <PricingFaq />
      <CheckoutDialog
        open={open}
        returnedPaymentId={returnedPaymentId}
        onOpenChange={(next) => {
          setCheckoutOpen(next);
          if (!next) {
            onCheckoutClosed();
          }
        }}
      />
    </main>
  );
};
